'use client';

import { H2Large, P } from 'components/home/styleConstants';
import React, { useRef } from 'react';
import styles from './ImageTextBlockLayout.module.css';
import { CustomImage as Image } from '..';
import { Container } from '..';

const SplitImageContainer = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.splitImageContainer}>{children}</div>
);

const SplitImage = ({
  children,
}: {
  fullHeight?: boolean;
  children: React.ReactNode;
}) => <div className={styles.splitImage}>{children}</div>;

const ImageTextContainer = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.imageTextContainer}>{children}</div>
);

const ImageWrapper = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.imageWrapper}>{children}</div>
);

const TextContainer = ({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) => (
  <div
    className={
      className ? `${styles.textContainer} ${className}` : styles.textContainer
    }
  >
    {children}
  </div>
);

const TextPara = ({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) => (
  <span
    className={className ? `${styles.textPara} ${className}` : styles.textPara}
  >
    {children}
  </span>
);

const BoldSpan = ({ children }: { children: React.ReactNode }) => (
  <span className={styles.boldSpan}>{children}</span>
);

const FullWidthRow = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.fullWidthRow}>{children}</div>
);

const TitleContainer = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.titleContainer}>{children}</div>
);

export const ImageTextBlockLayout = ({
  className,
  htmlId,
}: {
  className?: string;
  htmlId?: string;
}) => {
    const rootRef = useRef<HTMLDivElement>(null);

    return (
      <section
        className={className ? `${styles.root} ${className}` : styles.root}
        id={htmlId}
        ref={rootRef}
      >
        <Container>
          {/* <Wrapper> */}

          <ImageTextContainer>
            <TitleContainer>
              <H2Large>Tuned into your Home </H2Large>
              <P className={styles.titleP}>
                Ultrahuman Home works quietly in the background so you and your
                loved ones can sleep better.
              </P>
            </TitleContainer>
            {/* <TextPara className="independent">
              <BoldSpan>Blends effortlessly</BoldSpan> into your space, giving{' '}
              <BoldSpan>actionable insights</BoldSpan> exactly when you need
              them—no screens, no noise.
            </TextPara> */}
          </ImageTextContainer>
          <div style={{ marginTop: '1.6rem' }}>
            <SplitImageContainer>
              <SplitImage fullHeight={true}>
                <Image
                  src={
                    'web_v2/home/buy/image-text-block/Desktop/blockLayout.png/w_1080'
                  }
                  alt={
                    'web_v2/home/buy/image-text-block/Desktop/blockLayout.png/w_1080'
                  }
                  fill
                />
              </SplitImage>
              <ImageTextContainer>
                <ImageWrapper>
                  <SplitImage>
                    <Image
                      src={
                        'web_v2/home/buy/image-text-block/Desktop/img-b.png/w_1080'
                      }
                      alt={
                        'web_v2/home/buy/image-text-block/Desktop/img-b.png/w_1080'
                      }
                      fill
                      style={{
                        objectPosition: 'bottom',
                      }}
                    />
                  </SplitImage>
                </ImageWrapper>
                <TextContainer>
                  <TextPara>
                    {/* Engineered to <BoldSpan>enhance</BoldSpan> the health of
                    your <BoldSpan>living spaces</BoldSpan>, Home accurately
                    tracks environmental factors like{' '}
                    <BoldSpan>light, air quality, humidity</BoldSpan> and{' '}
                    <BoldSpan>noise</BoldSpan>. */}
                    Engineered to seamlessly <BoldSpan>blend</BoldSpan> into
                    your space, Ultrahuman Home improves your{' '}
                    <BoldSpan>sleep health</BoldSpan> without disrupting your
                    environment.
                  </TextPara>
                </TextContainer>
              </ImageTextContainer>
            </SplitImageContainer>

            {/* Second row with full-width image */}
            <FullWidthRow>
              <Image
                src={'web_v2/home/buy/desktop/carousel_lifestyle.jpg'}
                alt={'Full width image'}
                fill
                style={{
                  objectFit: 'cover',
                }}
              />
            </FullWidthRow>
          </div>
          {/* </Wrapper> */}
        </Container>
      </section>
    );
};
